<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="reservedInstanceList"
      style="width: 100.1%;"
      :max-height="tableHeight"
      :loading="modalLoading"
    >
      <template slot-scope="{ row, index }" slot="operation">
        <Button
          type="info"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:reservedInstanceResource:rds:config'
          ]"
          size="small"
          @click="configTag(row)"
          >{{ $t('RAM.AWS.reservedInstanceTag.configTag') }}</Button
        >
      </template>
    </Table>
    <!-- 配置标签页面 -->
    <configuration-reserved-instance-tag
      v-if="isShowReservedInstanceTag"
      ref="configurationReservedInstanceTag"
    ></configuration-reserved-instance-tag>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
import ConfigurationReservedInstanceTag from "../ConfigurationReservedInstanceTag";

var tableRelationalDatabaseServiceResourceVue = {};
export default {
  name: "TableRelationalDatabaseServiceResource",
  components: {
    ConfigurationReservedInstanceTag
  },
  data() {
    return {
      tableHeight: 0,
      isShowReservedInstanceTag: false,
      modalLoading: false,
      columns: [
        {
          title: this.$t("RAM.AWS.RI.RDS.accountID"),
          fixed: "left",
          minWidth: 120,
          key: "awsId"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.accountName"),
          minWidth: 150,
          key: "awsName"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: "tag",
          minWidth: 150,
          key: "tag"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.reservedInstanceID"),
          minWidth: 150,
          key: "id"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.engine"),
          minWidth: 150,
          key: "productDescription"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.instanceType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.paymentMethod"),
          minWidth: 150,
          key: "offeringType"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.status"),
          minWidth: 150,
          key: "state"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.start"),
          minWidth: 150,
          key: "start",
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.overdue"),
          minWidth: 150,
          key: "end",
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.due"),
          minWidth: 150,
          key: "duration"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.multipleAvailabilityZone"),
          minWidth: 150,
          key: "multiAZ"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.amount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.RI.RDS.standardizeFactor"),
          minWidth: 150,
          key: "matchingResult"
        },
        {
          title: this.$t("common.operation"),
          minWidth: 150,
          fixed: "right",
          slot: "operation"
        }
      ],
      reservedInstanceList: [],
      reservedInstanceListData: []
    };
  },
  beforeCreate: function() {
    tableRelationalDatabaseServiceResourceVue = this;
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 260;
    },
    // 显示数据
    getReservedInstances: function(reservedInstanceDTO) {
      tableRelationalDatabaseServiceResourceVue.reservedInstanceDTO = reservedInstanceDTO;
      // 转圈圈
      tableRelationalDatabaseServiceResourceVue.modalLoading = true;
      // 清空数据
      tableRelationalDatabaseServiceResourceVue.reservedInstanceList = [];
      tableRelationalDatabaseServiceResourceVue.$api.reservedInstance
        .getReservedDBInstances(reservedInstanceDTO)
        .then(res => {
          tableRelationalDatabaseServiceResourceVue.modalLoading = false;
          if (res == null || res.data == null) {
            return;
          }
          let reservedInstances = res.data;
          for (let i = 0; i < reservedInstances.length; i++) {
            reservedInstances[i].start = utils.methods.formatDate(
              reservedInstances[i].start
            );
            reservedInstances[i].end = utils.methods.formatDate(
              reservedInstances[i].end
            );
            reservedInstances[i].duration =
              reservedInstances[i].duration === 31536000
                ? tableRelationalDatabaseServiceResourceVue.$t(
                    "RAM.AWS.reservedInstanceTag.oneYear"
                  )
                : tableRelationalDatabaseServiceResourceVue.$t(
                    "RAM.AWS.reservedInstanceTag.threeYears"
                  );
            reservedInstances[i].multiAZ =
              reservedInstances[i].multiAZ === true
                ? tableRelationalDatabaseServiceResourceVue.$t("common.yes")
                : tableRelationalDatabaseServiceResourceVue.$t("common.no");
          }
          tableRelationalDatabaseServiceResourceVue.reservedInstanceListData = JSON.parse(
            JSON.stringify(reservedInstances)
          );
          tableRelationalDatabaseServiceResourceVue.reservedInstanceList = reservedInstances;
        });
    },
    configTag: function(row) {
      this.isShowReservedInstanceTag = true;
      this.$nextTick(function() {
        this.$refs.configurationReservedInstanceTag.getConfigurationReservedInstanceTagList(
          row,
          1
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/rds/TableRelationalDatabaseServiceResource.vue